//framework
import { memo, useState, useCallback } from 'react';
import { Howler } from 'howler';

//componets
import QRCode from 'qrcode.react';
import OutlineText from 'components/Shared/OutlineText/OutlineText';

//assets
import { IMAGES } from 'constants/constants';

//stlyes
import styles from './RoomDetails.module.scss';

//constants
import { APP_TYPES } from 'constants/appTypes';

const fullscreenAvailable =
    typeof document !== "undefined" &&
        (document.fullscreenEnabled || document.mozFullscreenEnabled || document.webkitFullscreenEnabled || document.msFullscreenEnabled) ? true : false;

function toggleFullScreen() {
    if (!fullscreenAvailable) return;
    const d = document;
    const isOn = d.fullscreenElement || d.webkitFullscreenElement || d.mozFullScreenElement || d.msFullscreenElement;
    const root = d.documentElement;

    if (!isOn) {
        (root.requestFullscreen || root.webkitRequestFullscreen || root.mozRequestFullScreen || root.msRequestFullscreen)?.call(root);
    } else {
        (d.exitFullscreen || d.webkitExitFullscreen || d.mozExitFullscreen || d.msExitFullscreen)?.call(d);
    }
}

const RoomDetails = memo(function RoomDetails({ url, displayUrl, mutedMusic, mutedSfx, roomId, onToggleMute, onToggleMenu, platform, hideButtons: hideButtonsProp, isMirror }) {
    const isTvApp = [APP_TYPES.ROKU, APP_TYPES.FIRE_TV].includes(platform);
    const hideAllButtons = hideButtonsProp && !isMirror || isTvApp;

    // Local mute state for mirrors (doesn't affect primary host's audio)
    const [localMuted, setLocalMuted] = useState(false);

    const handleMuteClick = useCallback(() => {
        if (isMirror) {
            const newMuted = !localMuted;
            Howler.mute(newMuted);
            setLocalMuted(newMuted);
        } else {
            onToggleMute();
        }
    }, [isMirror, localMuted, onToggleMute]);

    const isMuted = isMirror ? localMuted : (mutedMusic && mutedSfx);

    return (
        <div className={styles.roomCode}>
            <div className={styles.textBox}>
                <OutlineText parentStyles={styles} className={`${styles.text}`} text={displayUrl} />
                <OutlineText parentStyles={styles} className={`${styles.text}`} text={(<>Code: <span className={`${styles.code}`}>{roomId}</span></>)} />
                {isMirror && <div className={styles.mirrorBadge}>CONNECT</div>}

                {
                    !hideAllButtons &&
                    <div className={styles.iconsBox}>
                            <div className={styles.muteToggle} onClick={handleMuteClick}>
                                <img src={isMuted ? IMAGES.SHARED.mutedIcon : IMAGES.SHARED.unmutedIcon} className={styles.muteIcon} alt="mute" />
                        </div>
                        {
                            fullscreenAvailable &&
                                <div className={styles.muteToggle} onClick={() => toggleFullScreen()}>
                                        <img src={IMAGES.SHARED.fullscreenIcon} className={styles.muteIcon} alt="fullscreen" />
                                </div>
                        }
                        {
                            !isMirror &&
                            <div className={styles.muteToggle} onClick={() => onToggleMenu()}>
                                <img src={IMAGES.SHARED.menuIcon} className={styles.muteIcon} alt="help" />
                            </div>
                        }
                    </div>
                }
            </div>
            <div className={styles.qrCodeBox}>
                <QRCode
                    className={styles.qrCode}
                    value={`${url}/play/?qrCode=${roomId}`}
                    bgColor="rgba(0,0,0,0)"
                />
            </div>
        </div>
    )
});

export default RoomDetails;